<template>
  <div class="store-profile-filter-main-area">
    <div class="filter-header" v-if="showheading">
      <h4 class="is-size-5">Filter</h4>
      <a class="clear-filter-new is-size-7 font-color hover-text-primary" @click="clearFilter()">CLEAR ALL</a>
    </div>

    <div class="is-hidden-mobile">
      <div class="desktop-active-filter-tags" v-if="activeFilterTags.length > 0">
        <ul>
          <li @click="removeThisFilter(filterTags['key'], filterTags['val'])" v-for="filterTags  in activeFilterTags" v-bind:key="'filter_tag'+ filterTags['key'] + filterTags['val']">
            {{ filterTags['displayVal'] }}
            <i class="fas fa-times"></i>
          </li>
        </ul>
      </div>
    </div>

    <!-- sale item-->

    <div class="sale-filter control-section--filter">
      <div class="control variant-block has-text-centered">
        <input
          v-model="vg_filters.on_sale"
          class="is-checkradio is-block"
          id="size_filter"
          type="checkbox"
          name="size_filter"
          :value="1"
          :true-value="1"
          :false-value="0"
          @click="search"
        />
        <label for="size_filter" class="label-wrap with-border">
          <div class="variant-item-block has-text-centered">
            <div class="variant-price is-flex justify-content-center">
              <span class="mr5"> On Sale</span>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.475 19.575C12.175 19.875 11.8125 20.025 11.3875 20.025C10.9625 20.025 10.6 19.875 10.3 19.575L0.925 10.2C0.758333 10.0333 0.645833 9.85833 0.5875 9.675C0.529167 9.49167 0.5 9.3 0.5 9.1V1.5C0.5 1.06667 0.641667 0.708333 0.925 0.425C1.20833 0.141667 1.56667 0 2 0H9.6C9.8 0 10 0.0291668 10.2 0.0875001C10.4 0.145833 10.5833 0.258333 10.75 0.425L20.075 9.75C20.3917 10.0667 20.55 10.4375 20.55 10.8625C20.55 11.2875 20.3917 11.6583 20.075 11.975L12.475 19.575ZM11.45 18.55L19.05 10.95L9.6 1.5H2V9.1L11.45 18.55ZM4.625 5.4C4.975 5.4 5.27917 5.27083 5.5375 5.0125C5.79583 4.75417 5.925 4.45 5.925 4.1C5.925 3.75 5.79583 3.44583 5.5375 3.1875C5.27917 2.92917 4.975 2.8 4.625 2.8C4.275 2.8 3.97083 2.92917 3.7125 3.1875C3.45417 3.44583 3.325 3.75 3.325 4.1C3.325 4.45 3.45417 4.75417 3.7125 5.0125C3.97083 5.27083 4.275 5.4 4.625 5.4Z" fill="black"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.45 18.55L19.05 10.95L9.6 1.5H2V9.1L11.45 18.55ZM5.5375 5.0125C5.27917 5.27083 4.975 5.4 4.625 5.4C4.275 5.4 3.97083 5.27083 3.7125 5.0125C3.45417 4.75417 3.325 4.45 3.325 4.1C3.325 3.75 3.45417 3.44583 3.7125 3.1875C3.97083 2.92917 4.275 2.8 4.625 2.8C4.975 2.8 5.27917 2.92917 5.5375 3.1875C5.79583 3.44583 5.925 3.75 5.925 4.1C5.925 4.45 5.79583 4.75417 5.5375 5.0125Z" fill="#EF3C0C"/>
            </svg>

            </div>
          </div>
        </label>
      </div>
    </div>
  

    
    <!-- Sub category  -->
    <section class="control-section--filter search-brands search-size" v-if="activesubcategory && activesubcategory.length > 0">
      <label :class="'control-name font-color filter-heading-with-icon' + (open_from_categories ? ' reverse' : '') " @click.prevent="open_from_categories = !open_from_categories">Sub category <i class="fas fa-sort-down"></i></label>
      <div class="filter-radio-group open-height display-column child-100 mt15" v-if="open_from_categories">
        <div class="control variant-block-new-style" v-for="subcat in activesubcategory" v-bind:key="'subcat'+subcat.id">
          <input
            class="is-checkradio is-block"
            :id="'_subcat_id'+ subcat.id"
            type="checkbox"
            name="subcat"
            :value="subcat.id"
            @click="search"
            v-model="vg_filters.from_categories"
          />
          <label :for="'_subcat_id'+ subcat.id" class="label-wrap">
            <div class="variant-item-block">
              <div class="variant-price ">{{ subcat.name }}</div>
            </div>
          </label>
        </div>
      </div>
    </section>

    <!-- Weight -->

    <section class="control-section--filter product-types product-sizes" v-if="sizes && (sizes.length > 0)">
      <label :class="'control-name font-color filter-heading-with-icon' + (open_size ? ' reverse' : '') " @click.prevent="open_size = !open_size">Weights <i class="fas fa-sort-down"></i></label>
      <div class="filter-radio-group two-column-item mt15" v-if="open_size">
        <div class="control variant-block has-text-centered" v-bind:key="sizeIndex + '_size'" v-for="(size, sizeIndex) in sizes">
          <input
            v-model="vg_filters.size"
            class="is-checkradio is-block"
            :id="size"
            type="checkbox"
            name="size"
            :value="size"
            @click="search"
          />
          <label :for="size" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price">{{ size }}</div>
            </div>
          </label>
        </div>
      </div>
    </section>


    <section class="control-section--filter product-types">
      <label :class="'control-name font-color filter-heading-with-icon' + (open_plant_type ? ' reverse' : '') " @click.prevent="open_plant_type = !open_plant_type">Type <i class="fas fa-sort-down"></i></label>
      <div class="filter-radio-group mt15" v-if="open_plant_type">
        <div class="control variant-block has-text-centered">
          <input
            v-model="vg_filters.plant_type"
            class="is-checkradio is-block"
            id="product-type-two"
            type="checkbox"
            name="product-type"
            value="indica"
            @click="search"
          />
          <label for="product-type-two" class="label-wrap with-border">
            <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
              <!-- <div>
                <img :src="plant_type['indica']" alt="indica"/>
              </div> -->
              <div>Indica</div>
            </div>
          </label>
        </div>

        <div class="control variant-block has-text-centered">
          <input
            v-model="vg_filters.plant_type"
            class="is-checkradio is-block"
            id="product-type-one"
            type="checkbox"
            name="product-type"
            value="sativa"
            @click="search"
          />
          <label for="product-type-one" class="label-wrap with-border">
            <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
              <!-- <div>
                <img :src="plant_type['sativa']" alt="sativa"/>
              </div> -->
              <div>Sativa</div>
            </div>
          </label>
        </div>

        <div class="control variant-block has-text-centered">
          <input
            v-model="vg_filters.plant_type"
            class="is-checkradio is-block"
            id="product-type-three"
            type="checkbox"
            name="product-type"
            value="hybrid"
            @click="search"
          />
          <label for="product-type-three" class="label-wrap with-border">
            <div class="variant-item-block justify-content-center is-flex align-items-center height-full">
              <!-- <div>
                <img :src="plant_type['hybrid']" alt="hybrid" />
              </div> -->
              <div>Hybrid</div>
            </div>
          </label>
        </div>
      </div>
    </section>


    <!-- control: THC Content -->
    <!-- <section class="control-section--filter product-form with-intensity"> -->
    <section class="control-section--filter product-types with-intensity"> 
      <label :class="'control-name font-color filter-heading-with-icon' + (open_intensity ? ' reverse' : '') " @click.prevent="open_intensity = !open_intensity">Intensity <i class="fas fa-sort-down"></i></label>
      <div class="filter-radio-group mt15" v-if="open_intensity">
        <!-- <div :class="'control variant-block has-text-centered ' + ( index > 2 ? 'is-half': '')" v-bind:key="index+'_intensity'" v-for="(intensity,index) in active_intensity">
          <input
            class="is-checkradio is-block"
            :id="'intensity_'+index"
            type="checkbox"
            name="thc-content"
            :value="intensity.key"
            v-model="vg_filters[intensity.type]"
            @click="search"
          />
          <label :for="'intensity_'+ index" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price" v-html="intensity.label"></div>
            </div>
          </label>
        </div>  -->

        <div class="control variant-block has-text-centered">
          <input
            class="is-checkradio is-block"
            id="thc-content-low"
            type="checkbox"
            name="thc-content"
            value="low"
            v-model="vg_filters.thc"
            @click="search"
          />
          <label for="thc-content-low" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price ">THC<br/>Low</div>
            </div>
          </label>
        </div>

         <div class="control variant-block has-text-centered">
          <input
            class="is-checkradio is-block"
            id="thc-content-medium"
            type="checkbox"
            name="thc-content"
            value="medium"
            v-model="vg_filters.thc"
            @click="search"
          />
          <label for="thc-content-medium" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price ">THC <br/>Medium</div>
            </div>
          </label>
        </div>

        <div class="control variant-block has-text-centered">
          <input
            class="is-checkradio is-block"
            id="thc-content-high"
            type="checkbox"
            name="thc-content"
            value="high"
            v-model="vg_filters.thc"
            @click="search"
          />
          <label for="thc-content-high" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price ">THC<br/>High</div>
            </div>
          </label>
        </div>

 
        <!-- <div class="control variant-block  is-half has-text-centered">
          <input
            class="is-checkradio is-block"
            id="cbd"
            type="checkbox"
            name="thc-content"
            value="high"
            v-model="vg_filters.cbd"
            @click="search"
          />
          <label for="cbd" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price ">CBD</div>
            </div>
          </label>
        </div>

        <div class="control variant-block  is-half has-text-centered">
          <input
            class="is-checkradio is-block"
            id="balanced"
            type="checkbox"
            name="thc-content"
            value="balanced"
            v-model="vg_filters.cbd"
            @click="search"
          />
          <label for="balanced" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price ">Balanced</div>
            </div>
          </label>
        </div> -->
      
   
        <div class="control variant-block has-text-centered">
          <input
            class="is-checkradio is-block"
            id="cbd-content-low"
            type="checkbox"
            name="thc-content"
            value="low"
            v-model="vg_filters.cbd"
            @click="search"
          />
          <label for="cbd-content-low" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price ">CBD<br/>Low</div>
            </div>
          </label>
        </div>
        <div class="control variant-block has-text-centered">
          <input
            class="is-checkradio is-block"
            id="cbd-content-medium"
            type="checkbox"
            name="cbd-content"
            value="medium"
            v-model="vg_filters.cbd"
            @click="search"
          />
          <label for="cbd-content-medium" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price ">CBD<br/>Medium</div>
            </div>
          </label>
        </div>

        <div class="control variant-block has-text-centered">
          <input
            class="is-checkradio is-block"
            id="cbd-content-high"
            type="checkbox"
            name="cbd-content"
            value="high"
            v-model="vg_filters.cbd"
            @click="search"
          />
          <label for="cbd-content-high" class="label-wrap with-border">
            <div class="variant-item-block has-text-centered">
              <div class="variant-price ">CBD<br/>High</div>
            </div>
          </label>
        </div>
      </div>
    </section>

  
    <!--  Brands -->
    <section class="control-section--filter search-brands">
      <label :class="'control-name font-color filter-heading-with-icon' + (open_brand ? ' reverse' : '') " @click.prevent="open_brand = !open_brand">Brands <i class="fas fa-sort-down"></i></label>
      <div class="filter-radio-group display-column mt15 child-100" v-if="open_brand">
        <div class="control variant-block-new-style" v-bind:key="'brand_'+brand.id" v-for="brand in brands">
          <input
            class="is-checkradio is-block"
            :id="brand.id +'_brand_item'"
            type="checkbox"
            name="brand"
            :value="brand.name"
            v-model="vg_filters.brands"
            @click="search"
          />
          <label :for="brand.id +'_brand_item'" class="label-wrap">
            <div class="variant-item-block">
              <div class="variant-price">{{ brand.name }}</div>
            </div>
          </label>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import LocationApis from '@/Components/Controllers/LocationApis';
import UserApis from '@/Components/Controllers/UserApis';
import Env from "@/env";
import { mapGetters, mapActions } from "vuex";
import * as _ from 'lodash';
import Helpers from '@/Components/Helpers/Helpers';
import BrandApis from '@/Components/Controllers/BrandApis';

export default {
  props: ["sort", "sizes", "results", "showheading", "activesubcategory", "categoryintensity"],
  data() {
    return {
      filterActive: false,
      open_from_categories: true,
      open_sort: false,
      open_brand: false,
      open_size: true,
      open_plant_type: true, // is plant type
      open_intensity: true,
      has_intensity: false, // it depends on the categpry product cannabis attr product form
      brands: [],
      intensity_items: { // we are reverting this back and hard code to thc cbd
        'dried flower': [
          {
            key: 'high',
            label: 'High<br/>THC',
            type: 'thc',
          },
          {
            key: 'medium',
            label: 'Med<br/>THC',
            type: 'thc',
          },
          {
            key: 'low',
            label: 'Low<br/>THC',
            type: 'thc',
          },
          {
            key: 'balanced',
            label: 'Balanced',
            type: 'thc',
          },
          {
            key: 'high',
            label: 'High CBD',
            type: 'cbd',
          }
        ],
        
        'vapes': [
          {
             key: 'dormant',
            label: 'THC<br/>Dormant',
            type: 'thc',
          },
          {
            key: 'balanced',
            label: 'Balanced',
            type: 'thc',
          },
          {
            key: 'dormant',
            label: 'CBD<br/>Dormant',
            type: 'cbd',
          },
        ],

        'edibles': [
          {
             key: 'dormant',
            label: 'THC<br/>Dormant',
            type: 'thc',
          },
          {
            key: 'balanced',
            label: 'Balanced',
            type: 'thc',
          },
          {
            key: 'dormant',
            label: 'CBD<br/>Dormant',
            type: 'cbd',
          },
        ],

        'beverages': [
          {
             key: 'dormant',
            label: 'THC<br/>Dormant',
            type: 'thc',
          },
          {
            key: 'balanced',
            label: 'Balanced',
            type: 'thc',
          },
          {
            key: 'dormant',
            label: 'CBD<br/>Dormant',
            type: 'cbd',
          },
        ],

        'concentrates': [
          {
            key: 'high',
            label: 'High<br/>THC',
            type: 'thc',
          },
          {
            key: 'medium',
            label: 'Med<br/>THC',
            type: 'thc',
          },
          {
            key: 'low',
            label: 'Low<br/>THC',
            type: 'thc',
          },
          {
            key: 'balanced',
            label: 'Balanced',
            type: 'thc',
          },
          {
            key: 'high',
            label: 'High CBD',
            type: 'cbd',
          }
        ],

        'extracts': [
           {
             key: 'dormant',
            label: 'THC<br/>Dormant',
            type: 'thc',
          },
          {
            key: 'balanced',
            label: 'Balanced',
            type: 'thc',
          },
          {
            key: 'dormant',
            label: 'CBD<br/>Dormant',
            type: 'cbd',
          }, 
        ],

      },
      // filter: {
      //   plant_type: [],
      //   product_form: [],
      //   thc: [],
      //   cbd: [],
      //   sort: '',
      //   brands: [],
      // }
    };
  },

  computed: {
    ...mapGetters({
      vg_userId: "getLoggedInUserId",
      vg_filters: "searchproduct/searchFilter",
      vg_selectedStore: "location/selected",
      vg_currentActiveCategory: "searchproduct/currentActiveCategory",
    }),

    /**
     * Gives active filter tags
     */
    activeFilterTags() {
      return Helpers.getActiveFilterTags(this.vg_filters);
    },

    plant_type() {
      return Env.product_type;
    },

    active_intensity() {
      let value = this.intensity_items[this.categoryintensity];
      if(value){
        return value;
      }
      return null;
    },

  },
  
  watch: {

    vg_filters: {
      handler: function () {
        // hitting multiple so prevent this
        // this.search();
      },
      deep: true
    },

    'sort'(val) {
      this.vg_filters.sort = val;
      this.search();
    },

  },

  created() {
  //  console.log(this.vg_selectedStore.id)
  
  },

  async mounted() {
    
    let res = await BrandApis.fetchBrands(this.vg_selectedStore.id);
    this.brands = (res.status == 200) ? res.data.payload : [];
 
    // Listen to clear filter 
    bus.$on('clear-filter', (payload) => {
      // Watch emit for clear filter
      if(payload){
        this.va_resetFilters();
        // this.filter = {
        //   plant_type: [],
        //   product_form: [],
        //   thc: [],
        //   size: [],
        //   cbd: [],
        //   sort: '',
        //   brands: [],
        // };
        this.search();
      }
    })

    // listen to filter now
    bus.$on('filter-now', (payload) => {
      // Watch emit for clear filter
      if(payload){
        this.search();
      }
    })
  },

  beforeDestroy() {
    bus.$off('clear-filter');
    bus.$off('filter-now');
  },

  
  methods: {
    /**
     * Close filter right sidebar  search: _.debounce(function(){
     */
    search: _.debounce(function(){

      /**
       * before we search we need to save the current selected category + its subcat
       * so that if in search it doesnot exist we need to add as first item
       */

      // If user is logged in pass his search params
      if(this.vg_userId){
        // Pass parent category
        this.vg_filters.parent_category = this.vg_currentActiveCategory.id;
        UserApis.pushUserFilters({
          location_id: this.vg_selectedStore.id,
          filters: this.vg_filters
        });
      }
      

      // on search create filter params 
      bus.$emit('loaded-filtered-product', false);
      const self = this;
      let params = Helpers.generateUrlParameter(this.vg_filters);
      let paramsNoSubCat = Helpers.generateUrlParameterIgnoreSubcat(this.vg_filters);

      //let featuredProductsPromise =  LocationApis.featuredProducts(this.vg_selectedStore.id, params);

      // only hit if there is any subcat selected
      let categoryProductsWithSubCatPromise;
      // lets prevent hitting api for subcat if filter cat is null
      if(this.vg_filters.from_categories.length > 0){
        categoryProductsWithSubCatPromise = LocationApis.categoryWithProducts(this.vg_selectedStore.id, params);
      } else {
        categoryProductsWithSubCatPromise = null;
      }

      // this return main cats so hit always 
      let categoryWithProductsWithoutSubCatPromise = LocationApis.categoryWithProducts(this.vg_selectedStore.id, paramsNoSubCat);
      
      Promise.all([categoryWithProductsWithoutSubCatPromise, categoryProductsWithSubCatPromise]).then(function(res) {
        bus.$emit('filtered-store-categories', res);
        // After we pass the values its taking quite time to show result because of lots of filter and maping
        if(params == ''){
          self.filterActive = false;
          bus.$emit('store-profile-active-filter', false);
        } else {
          self.filterActive = true;
          bus.$emit('store-profile-active-filter', true);
        }
      })
      
     }, 800),
    
    /**
     * Clear filters
     */
    async clearFilter() {
      await this.va_resetFilters();
      this.search();
    },

    /**
     * Remove filter from mobile
     */
    removeThisFilter(key, val){
      // first remove key value from filter then do search 
      for(let filterKey in this.vg_filters){
        if(filterKey == key){    
          // If this key is array      
          if ( (Array.isArray(this.vg_filters[filterKey])) && (this.vg_filters[filterKey].length > 0)) {
            this.vg_filters[key] = this.vg_filters[filterKey].filter(e => e !== val)
          } else {
            // It must be string set val to blank
            this.vg_filters[key] = (typeof val ==  'boolean')  ? 0 : '';
          }
        }
      }
      this.search();
    },

    ...mapActions({
      va_resetFilters: "searchproduct/setEmptySearchFilter",
    })
  },
  
};
</script>
